export default __webpack_public_path__ + "static/media/Group -3.1b5c3115.png";